import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { useThemeContext } from '../../../hook/useThemeManager';
import { ColorScheme, theme } from '../../../constants/theme';
import { Box, Typography, Slide, Button } from '@mui/material';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import close from '../../../asset/images/icons/es_x_close.svg';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import { DiscoveryFilter, FilterItem, FilterTypes, mainCategorySelector } from '../../../data/filters/discovery.data';
import { MobileFilterBlock } from './MobileFilterBlock';
import { FilterTab } from './FilterTab';
import { FilterValueSet } from '../../../redux/appConfigurator/types';
import { toggleDrawer, toggleFiler } from '../../../redux/appConfigurator/action';
import { useDispatch, useSelector } from 'react-redux';
import { filterSubCategoryIdSelector } from '../../../selectors/selectors';
import { strings } from '../../../constants';
import { MobileLocationSeletor } from './MobileLocationSeletor';
import { isEmpty } from '../../../utils/lodash';
import CustomLazyLoadImage from '../../Image/CustomLazyLoadImage';

export interface IFilterMobile {
    filterList: DiscoveryFilter[];
    filtersScreen: boolean;
    handleFiltersScreen: () => void;
    onChangeFilterCategory: (filter: FilterItem, categoryId?: number) => void;
    onFilterSelect: (categoryName: string, filterItem: FilterItem, categoryId: number) => void;
    selectedCategory: FilterTypes;
    filterSelections: FilterValueSet;
    onClearFilter: () => void;
    disableFilter: boolean;
    openMap: boolean;
    setOpenMap: () => void;
    onClose: () => void;
}

const EsFiltersScreenMobile: React.FC<IFilterMobile> = ({
    handleFiltersScreen,
    filtersScreen,
    filterList,
    onChangeFilterCategory,
    selectedCategory,
    onFilterSelect,
    filterSelections,
    onClearFilter,
    disableFilter,
    openMap,
    setOpenMap,
    onClose,
}) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const [isMaincategoryOpen, setIsMainCategoryOpen] = useState<boolean>(false);
    const selectedFilterSubCategoryId = useSelector(filterSubCategoryIdSelector);
    const dispatch = useDispatch();

    const handleFilterOpening = (filterGroupId?: number) => {
        dispatch(
            toggleFiler({
                filterStatus: isMaincategoryOpen ? 'on' : 'off',
                filterId: selectedFilterSubCategoryId === filterGroupId ? undefined : filterGroupId,
            }),
        );
        setIsMainCategoryOpen(!isMaincategoryOpen);
        dispatch(toggleDrawer({ status: 'closed' }));
    };

    return (
        <Modal
            open={filtersScreen}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 600,
                },
            }}>
            <Slide in={filtersScreen} direction="left" mountOnEnter unmountOnExit>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        flexDirection: 'column',
                        backgroundColor: theme[themeStyle].pure_black,
                        zIndex: 10,
                        overflow: 'scroll',
                    }}>
                    <Box
                        sx={{
                            displa: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: 'full',
                            width: '100%',
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                height: '102px',
                                width: '95%',
                                marginLeft: '16px',
                                transition: 'all 400ms ease',
                                borderBottom: `1px solid ${theme[themeStyle].gray_text}`,
                                minHeight: '100px',
                            }}>
                            <Box
                                sx={{
                                    width: '50%',
                                    gap: '10px',
                                    marginRight: '16px',
                                    marginBlock: 10,
                                }}>
                                <Typography style={styles.screenTitle}>{strings.filter_by}</Typography>
                                {mainCategorySelector.map((filter, index) => (
                                    <FilterTab
                                        category={selectedCategory}
                                        key={index.toString()}
                                        data={filter}
                                        onChange={d => console.log(d)}
                                        open={selectedFilterSubCategoryId === filter.id}
                                        onFilterPressed={handleFilterOpening}
                                        isSolidButton
                                        selectedValue={selectedCategory}
                                        onFilterSelect={(filter, categoryId) =>
                                            onChangeFilterCategory && onChangeFilterCategory(filter, categoryId)
                                        }
                                    />
                                ))}
                            </Box>

                            <CustomLazyLoadImage
                                src={close}
                                alt="close dropdown icon"
                                onClick={onClose}
                                style={{ cursor: 'pointer', marginRight: '8px' }}
                            />
                        </Box>
                        {/* Date */}
                        {!!filterList &&
                            !isEmpty(filterList) &&
                            filterList.map((card, index) => {
                                const selected =
                                    !isEmpty(filterSelections) &&
                                    filterSelections[card.id] &&
                                    filterSelections[card.id].displayName
                                        ? filterSelections[card.id].displayName
                                        : card.categoryName;
                                if (card.categoryName.toLowerCase() === 'select location') {
                                    return (
                                        <MobileLocationSeletor
                                            data={card}
                                            openMap={openMap}
                                            setOpenMap={setOpenMap}
                                            category={card.categoryName}
                                            selectedValue={selected}
                                            key={index.toString()}
                                            onFilterSelect={(selectedFilter, categoryId) => {
                                                onFilterSelect(card.categoryName, selectedFilter, categoryId);
                                            }}
                                        />
                                    );
                                }
                                return (
                                    <MobileFilterBlock
                                        data={card}
                                        category={card.categoryName}
                                        selectedValue={selected}
                                        key={index.toString()}
                                        disableLine={index === filterList.length - 1}
                                        onFilterSelect={(selectedFilter, categoryId) => {
                                            onFilterSelect(card.categoryName, selectedFilter, categoryId);
                                        }}
                                    />
                                );
                            })}
                    </Box>

                    {/* Buttons */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            height: '82px',
                            minHeight: '82px',
                            borderTop: `1px solid ${theme[themeStyle].gray_text}`,
                            gap: '12px',
                            width: '100%',
                        }}>
                        <Button
                            style={styles.mainButton}
                            sx={{
                                width: '75px',
                                gap: '8px',
                                backgroundColor: theme[themeStyle].pure_black,
                                border: `1px solid ${theme[themeStyle].primary_white}`,
                            }}
                            onClick={onClearFilter}>
                            <Typography style={styles.title} sx={{ color: theme[themeStyle].primary_white }}>
                                {strings.reset}
                            </Typography>
                        </Button>

                        <Button
                            style={styles.mainButton}
                            disabled={disableFilter}
                            sx={{
                                width: '200px',
                                gap: '8px',
                                backgroundColor: disableFilter
                                    ? theme[themeStyle].disabledGray
                                    : theme[themeStyle].primary_orange,
                                marginRight: '15px',
                            }}
                            onClick={handleFiltersScreen}>
                            <Typography style={styles.title} sx={{ color: theme[themeStyle].pure_black }}>
                                {strings.show_results}
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        mainButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 100,
            height: '40px',
            paddingBottom: 10,
            paddingTop: 10,
            paddingLeft: 5,
            paddingRight: 5,
            textTransform: 'none',
        },
        screenTitle: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
            padding: 5,
        },
        mainText: {
            width: 'fit-content',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: '600',
            color: theme[colorScheme].pure_black,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        title: {
            fontSize: 16,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        caption: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        dropdown: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            width: '100%',
            height: 'fit-content',
            padding: '4px',
            paddingLeft: 16,
            paddingRight: 16,
            marginTop: '26px',
        },
        titleScreen: {
            fontSize: 12,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            color: theme[colorScheme].form_label,
        },
        text: {
            width: 'fit-content%',
            textAlign: 'left',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: '600',
            fontFamily: FONT_ENUM.MAIN_BOLD,
            color: theme[colorScheme].filters_white,
        },
    });

export { EsFiltersScreenMobile };
